<script>

import Constants from '../constants';

import commonFooter from '@/components/commonFooter';
import commonNav from '@/components/commonNav';
import shareBtn from '@/components/shareBtn';

import moveTextHover from '@/components/moveTextHover';
import hoverDesign from '@/components/hoverDesign';

import setMetaUtil from '@/util/setMetaUtil';

export default {
  name: Constants.ROUTER.DISTRIBUTION,
  components: {
    commonFooter,
    commonNav,
    shareBtn,
    moveTextHover,
    hoverDesign,
  },
  data() {
    return {
      ready: false,
      windowHeight: Constants.WINDOW.MIN_HEIGHT.viewSm,

      albumId: 14,
      targetcdData: {},
    };
  },
  created() {
    this.getCdData(this.$route.query.id);
    
    setMetaUtil.setMeta(
        this,
        document,
        `${this.$i18n.messages.ja.message.distribution.pageName
        } - ${this.$i18n.messages.ja.message.discography.albums[`a${this.albumId}`].name
        } - ${this.$i18n.messages.ja.message.bandName}`,
        `${this.$i18n.messages.ja.message.discography.albums[`a${this.albumId}`].name
        } - ${this.$i18n.messages.ja.message.distribution.description}`,
        `/ogImage_album${this.albumId}`,
      );

    document.dispatchEvent(new Event('custom-render-trigger'));

    window.onscroll = () => { this.onscroll(); }
    window.onresize = () => { this.onscroll(); }
    this.onscroll();

    setTimeout(()=> {
      this.ready = true;
    }, 1);
  },
  methods: {
    getCdData() {
      this.albumId = Number(this.$route.path.replace(/\/$/, '').split(Constants.ROUTER.DISTRIBUTION)[1]);

      this.targetcdData = Constants.ALBUM[`ALBUM${this.albumId}`];

      if (!this.targetcdData) { // クエリの数字がおかしい場合
        this.$router.push({ name: Constants.ROUTER.NOTFOUND });
        return;
      }
    },

    moveToAlbum() {
      this.$router.push({ name: Constants.ROUTER[`ALBUM${this.albumId}`], });
    },

    moveToCautionsToDlSale() {
      this.$router.push({ name: Constants.ROUTER.ABOUTSITE });
    },

    onscroll() {
      const minHeight = Constants.WINDOW.MIN_HEIGHT[this.$mq];
      this.windowHeight = window.innerHeight < minHeight ? minHeight : window.innerHeight;
    },
  }
};
</script>

<template>
  <div class="view-distribution page" :class="ready ? 'is-ready' : ''">
    <common-nav/>
    <div id="contents-main" :style="{'min-height': windowHeight + 'px'}">
      <div class="album-title">{{$t(`message.discography.albums.a${this.albumId}.name`)}}</div>

      <!-- 委託 -->
      <div class="contents-container" v-if="targetcdData.SHOP.length > 0">
        <div class="title">{{$t('message.discography.sale')}}</div>
        <div v-for="shop in targetcdData.SHOP" :key="shop.shop">
          <a
            class="banner200x40"
            :class="shop.shop"
            :title="$t(`message.shop.${shop.shop}`)"
            target="_blank"
            :href="shop.url"
          ><hover-design/></a>
          <a
            :title="$t(`message.shop.${shop.shop}`)"
            target="_blank"
            :href="shop.url"
            class="text"
          >
            <move-text-hover :target-text="$t(`message.shop.${shop.shop}`)" />
          </a>
        </div>
      </div>

      <!-- ストリーミング -->
      <div class="contents-container" v-if="targetcdData.DISTRIBUTION.length > 0">
        <div class="title">{{$t('message.distribution.streaming')}}</div>
        <div v-for="shop in targetcdData.DISTRIBUTION" :key="shop.shop">
          <a
            class="banner200x40"
            :class="shop.shop"
            :title="$t(`message.shop.${shop.shop}`)"
            target="_blank"
            :href="shop.url"
          ><hover-design/></a>
          <a
            :title="$t(`message.shop.${shop.shop}`)"
            target="_blank"
            :href="shop.url"
            class="text"
          >
            <move-text-hover :target-text="$t(`message.shop.${shop.shop}`)" />
          </a>
        </div>
      </div>

      <!-- DL -->
      <div class="contents-container" v-if="targetcdData.DL.length > 0">
        <div class="title">{{$t('message.discography.dlSale')}}</div>
        <div v-for="shop in targetcdData.DL" :key="shop.shop">
          <a
            class="banner200x40"
            :class="shop.shop"
            :title="$t(`message.shop.${shop.shop}`)"
            target="_blank"
            :href="shop.url"
          ><hover-design/></a>
          <a
            :title="$t(`message.shop.${shop.shop}`)"
            target="_blank"
            :href="shop.url"
            class="text"
          >
            <move-text-hover :target-text="$t(`message.shop.${shop.shop}`)" />
          </a>
        </div>

        <div class="caution" @click="moveToCautionsToDlSale">
          <move-text-hover :target-text="$t('message.distribution.cautionsToDlSale')" />
        </div>
      </div>

      <!--スペシャル-->
      <div class="contents-container" v-if="targetcdData.SPECIAL.length > 0">
        <div v-for="contents in targetcdData.SPECIAL" :key="contents.banner">
          <a
            class="banner200x40"
            :class="contents.banner"
            :title="$t(`message.shop.${contents.banner}`)"
            target="_blank"
            :href="contents.url"
          ><hover-design/></a>
          <a
            :title="$t(`message.shop.${contents.title}`)"
            target="_blank"
            :href="contents.url"
            class="text"
          >
            <move-text-hover :target-text="$t(contents.title)" />
          </a>
        </div>
      </div>

      <!-- その他 -->
      <div class="contents-container" v-if="targetcdData.ETC.length > 0">
        <div class="title">{{$t('message.distribution.etc')}}</div>
        <div v-for="shop in targetcdData.ETC" :key="shop.shop">
          <a
            class="banner200x40"
            :class="shop.shop"
            :title="$t(`message.shop.${shop.shop}`)"
            target="_blank"
            :href="shop.url"
          ><hover-design/></a>
          <a
            :title="$t(`message.shop.${shop.shop}`)"
            target="_blank"
            :href="shop.url"
            class="text"
          >
            <move-text-hover :target-text="$t(`message.shop.${shop.shop}`)" />
          </a>
        </div>
      </div>
      

      <!-- 戻る -->
      <div class="return" @click="moveToAlbum">
        <move-text-hover :target-text="$t('message.distribution.goToAlbum')" />
      </div>

    </div>
    <common-footer/>
    <share-btn :is-fixed="true"/>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .page {
    position: relative;
    #contents-main {
      padding-top: $commonNavHeight;
      padding-top: 50px;
      text-align: center;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      // 中央寄せ
      justify-content: center;
      align-items: center;
      .album-title {
        font-size: 1.2em;
        margin-bottom: 30px;
      }
      .contents-container {
        margin-bottom: 50px;
        .banner200x40 {
          position: relative;
          margin: 20px auto 0 auto;
          transition: 0.1s ease-out;
          &:hover {
            transform: scale(1.1);
          }
        }
        .text {
          font-size: 0.7em;
        }
        .caution {
          margin-top: 30px;
        }
      }

      .return {
        margin-bottom: 30px;
      }
      
    }
  }
</style>
